<div class="support">
    <app-new-header></app-new-header>

    <div class="section_one" style="background-image: url('../../../../assets/img/dotted-map.jpg')">
        <div class="overlay">
            <div class="left">
                <div>CONTACT US</div>
                <h3>Get closer with us</h3>
                <p>Reach out to us through any means below and we will get back to you shortly</p>
    
                <div class="buttons">
                    <a href="https://dashboard.huiospay.com/registration/67a09908-6119-11ee-bfbe-7a0e4acd3f16" target="_blank">
                        <button>Become Merchant</button>
                    </a>
                    <button class="become-agent" (click)="showModal = true">Become a POS Agent</button>
                </div>
            </div>
            
        </div>
    </div>

    <div class="enquires">
        <div class="wrapper">
            <div class="left">
                <form class="form" [formGroup]="supportForm" (ngSubmit)="onSubmit()">

                    <div *ngIf="submitAlert" class="submit-alert" [class.is-success]="submitAlert.type === 'success'" [class.is-error]="submitAlert.type === 'error'">
                        {{ submitAlert.message }}
                    </div>

                    <div class="fields">
                        <div class="field">
                            <span>First Name</span>
                            <input type="text" formControlName="firstName" placeholder="e.g John">
                            <small class="field-error" *ngIf="supportForm.get('firstName')!.invalid && supportForm.get('firstName')!.touched">First name is required</small>
                        </div>

                        <div class="field">
                            <span>Last Name</span>
                            <input type="text" formControlName="lastName" placeholder="e.g Doe">
                            <small class="field-error" *ngIf="supportForm.get('lastName')!.invalid && supportForm.get('lastName')!.touched">Last name is required</small>
                        </div>
                    </div>

                    <div class="field standalone">
                        <span>Email Address</span>
                        <input type="email" formControlName="email" placeholder="e.g john.doe@example.com">
                        <small class="field-error" *ngIf="supportForm.get('email')!.invalid && supportForm.get('email')!.touched">Valid email is required</small>
                    </div>

                    <div class="field standalone">
                        <span>Issue</span>
                        <input type="text" formControlName="issue" placeholder="e.g. Enquiry on POS device">
                        <small class="field-error" *ngIf="supportForm.get('issue')!.invalid && supportForm.get('issue')!.touched">Please describe your issue</small>
                    </div>

                    <div class="field standalone">
                        <span>Message</span>
                        <textarea formControlName="message" placeholder="Leave a message"></textarea>
                        <small class="field-error" *ngIf="supportForm.get('message')!.invalid && supportForm.get('message')!.touched">Message is required</small>
                    </div>

                    <div class="g-recaptcha" data-sitekey="6LfjOYwsAAAAAFV7k4sAv2b4mapu6AQpAeSAGBnw"></div>

                    <button class="submit-btn" type="submit" [disabled]="isSubmitting">
                        {{ isSubmitting ? 'Sending...' : 'Send a message' }}
                    </button>
                </form>
            </div>
    
            <div class="right">
                <div class="item">
                    <h3>Address</h3>
                    <p>1st floor, AP Plaza, 28 Adetokunbo Ademola Cresent Wuse 2, Abuja</p>
                </div>
    
                <div class="item">
                    <h3>Phone Number</h3>
                    <p><a href="tel:08037086670">08037086670</a></p>
                </div>
    
                <div class="item">
                    <h3>Email Address</h3>
                    <p><a href="mailto:contactus@huiospay.com">contactus@huiospay.com</a></p>
                </div>
            </div>
        </div>
    </div>

    <app-map-section></app-map-section>

    <div class="section_seven" style="background-image: url('../../../../assets/img/section7.jpg');">
        <div class="join">
            <h3>Join our agent network</h3>
    
            <p>Grow your business by becoming a Huiospay merchant or POS agent.
                We handle the payments, you handle the growth.</p>
    
            <button (click)="showModal = true">Become POS Merchant</button>
        </div>
    </div>
    
    <app-new-footer></app-new-footer>
</div>

<app-pos-merchant-modal [isOpen]="showModal" (closed)="showModal = false"></app-pos-merchant-modal>